
export interface IVIPCertificateMeans {
	used_design_office?: boolean;
	used_laboratory?: boolean;
	specific_material?: string;
	other_means?: string;
}

export function createCertificateMeans(): IVIPCertificateMeans {
	return {
		used_design_office: false,
		used_laboratory: false,
		specific_material: "",
		other_means: "",
	};
}

export function checkCertificateMeans(data: IVIPCertificateMeans) {
	if (data.used_design_office === undefined) {
		data.used_design_office = false;
	}
	if (data.used_laboratory === undefined) {
		data.used_laboratory = false;
	}
	if (data.specific_material === undefined) {
		data.specific_material = "";
	}
	if (data.other_means === undefined) {
		data.other_means = "";
	}
}
